// This following is only necessary due to an issue with the AWS Amplify library
// similar issue: https://stackoverflow.com/questions/61555262/aws-amplify-js-to-angular-app-has-error-global-is-not-defined
window.global = window;
